module.exports = __webpack_public_path__ + "img/rosepetal-dep-aisvision.0ac502e2.jpg";